import { authorizedRequest, logout } from "./account";
import { responseError } from "./errors";

require("dotenv").config();

const ENV = process.env;

export const REQUEST_REGIONS = "REQUEST_REGIONS";
export const RECEIVE_REGIONS = "RECEIVE_REGIONS";
export const RECEIVE_REGION = "RECEIVE_REGION";
const ENDPOINT_PATH = "dst-regions";

export const requestDstRegions = () => ({
  type: REQUEST_REGIONS,
});

export const receivedDstRegions = (json) => ({
  type: RECEIVE_REGIONS,
  json,
});

export const receivedDstRegion = (json) => ({
  type: RECEIVE_REGION,
  json,
});

export const createDstRegion = (params) => (dispatch) => {
  dispatch(requestDstRegions());
  const headers = {};
  headers["Content-Type"] = "application/json";
  return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  })
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(responseError("Unauthorized"));
      }
      return json;
    });
};

export const deleteDstRegion = (id) => (dispatch) => {
  dispatch(requestDstRegions());
  return authorizedRequest(
    `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}/${id}`,
    { method: "DELETE", headers: {} },
  )
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(responseError("Unauthorized"));
      }
      return json;
    });
};

export const fetchDstRegions = (sort) => (dispatch) => {
  dispatch(requestDstRegions());
  let url = `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}`;
  if (sort) url += `?order=${JSON.stringify(sort)}`;
  return authorizedRequest(url, { method: "GET" })
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
        dispatch(receivedDstRegions([]));
      } else if (json.status === 401) {
        dispatch(logout());
        dispatch(receivedDstRegions([]));
      } else {
        dispatch(receivedDstRegions({ data: json } || []));
      }
      return json;
    });
};

export const fetchDstRegion = (id) => (dispatch) => {
  dispatch(requestDstRegions());
  return authorizedRequest(
    `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}/${id}`,
    { method: "GET" },
  )
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(logout());
      } else {
        dispatch(receivedDstRegion(json));
      }
      return json;
    });
};

export const saveDstRegion = (id, params) => (dispatch) => {
  dispatch(requestDstRegions());
  const headers = {};
  headers["Content-Type"] = "application/json";
  return authorizedRequest(
    `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}/${id}`,
    { method: "POST", headers, body: JSON.stringify(params) },
  )
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(responseError("Unauthorized"));
      }
      return json;
    });
};
